"use client";

import * as React from "react";
import { Accordion, AccordionContent, AccordionItem, AccordionTrigger } from "@/components/ui/accordion";
import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
import { cn } from "@/lib/utils";
const faqs = [{
  question: "Are you a lending source?",
  answer: "No, Lana Connect LLC is not a lender. We serve as a specialized bridge, connecting homeowners and contractors with established financing platforms. Our role is to provide the 'One Connection' needed to access a variety of funding sources in the field."
}, {
  question: "How does the connection process work?",
  answer: "Our process is simple and transparent. We evaluate your project needs and introduce you to our network of financing partners. This allows homeowners to secure funding for their projects and helps contractors offer professional financing solutions to their clients."
}, {
  question: "How does this benefit contractors?",
  answer: "By partnering with Lana Connect, contractors can provide their clients with immediate access to financing options. This helps homeowners commit to larger projects with confidence, effectively streamlining the sales process for the contractor."
}, {
  question: "What types of projects can be financed?",
  answer: "Our network of financing sources covers a wide spectrum of home improvement and construction projects. Whether it's a minor renovation or a major structural addition, we help find the right platform to fund the vision."
}, {
  question: "Is there a cost to use Lana Connect?",
  answer: "We focus on creating value through expertise and connection. We operate with full transparency regarding our service structure, ensuring that homeowners and contractors understand how we facilitate these vital financial introductions."
}];
export default function BillingClarified() {
  const {
    ref,
    isVisible
  } = useRevealOnScroll();
  return <section data-section-id="1675" id="common-inquiries" ref={ref} className={cn("bg-background py-20 transition-opacity duration-700", isVisible ? "opacity-100" : "opacity-0")}>
      <div className="container mx-auto px-4">
        <div className="mx-auto max-w-[800px]">
          <div className="mb-12 text-center">
            <h2 className="text-3xl font-bold tracking-tight text-foreground sm:text-4xl">
              Clear Answers for Your Peace of Mind
            </h2>
            <p className="mt-4 text-lg text-muted-foreground">
              Experts, One Connection. Straightforward answers to your most common questions about how we bridge the gap.
            </p>
          </div>

          <Accordion type="single" collapsible className="w-full">
            {faqs.map((faq, i) => <AccordionItem key={i} value={`item-${i}`} data-index={i}>
                <AccordionTrigger className="text-[18px] font-bold text-foreground hover:no-underline hover:text-ring transition-colors text-left">
                  {faq.question}
                </AccordionTrigger>
                <AccordionContent className="text-base text-muted-foreground leading-relaxed">
                  {faq.answer}
                </AccordionContent>
              </AccordionItem>)}
          </Accordion>
        </div>
      </div>
    </section>;
}